import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

export const Supportfaq = () => {
    const navigate = useNavigate();

    return (
        <>
            <button onClick={() => navigate("/dashboard")}>
                Go to About Page
            </button>
            <br/>
            <Link to="/dashboard">
                dashboard
            </Link>
            <div>Supportfaq</div>

        </>
    )
}
